import { useEffect, useRef } from 'react';
import type { PropsWithChildren } from 'react';

import FileBrowserScrollContext from './fileBrowserScrollContext';
import { useFileBrowserContext } from './hook';

const VFileBrowserScrollContextProvider = ({ children }: PropsWithChildren) => {
  const $scrollable = useRef<HTMLDivElement>(null);
  const { lastSelectedItemUuid } = useFileBrowserContext();

  const moveScroll = <E extends HTMLElement>($item: E) => {
    const itemHeight = $item.offsetHeight;
    const itemY = $item.offsetTop;
    const scrollableHeight = $scrollable.current!.offsetHeight;

    $scrollable.current!.scroll({
      behavior: 'smooth',
      top: itemY - (scrollableHeight >> 1) + (itemHeight >> 1),
    });
  };

  useEffect(() => {
    if (!lastSelectedItemUuid || !$scrollable.current) return;

    const $item = $scrollable.current.querySelector<HTMLElement>(
      `[data-id="${lastSelectedItemUuid}"] [role="presentation"]`,
    )!;

    if (!$item) return;

    moveScroll($item);
  }, [lastSelectedItemUuid]);

  return (
    <FileBrowserScrollContext.Provider
      value={{
        $scrollable,
      }}
    >
      {children}
    </FileBrowserScrollContext.Provider>
  );
};

export default VFileBrowserScrollContextProvider;
